export const pxToRem = (size: number, htmlFontSize = 16) =>
  `${size / htmlFontSize}rem`
